import { render, staticRenderFns } from "./BModal.vue?vue&type=template&id=1efd69ce&"
import script from "./BModal.vue?vue&type=script&lang=js&"
export * from "./BModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports